import { Box, Text, TextField } from "@radix-ui/themes";
import { Control, Controller, FieldErrors, FieldValues, Path} from "react-hook-form";
import styles from './TextfieldComponent.module.scss';
interface TextFieldProps<T extends FieldValues> {
  name: Path<T>; // Agora restrito apenas a chaves de `T`
  label: string;
  control: Control<T>;
  errors: FieldErrors<T>;
  style?: any;
  fieldProps?: any;
  composedName?: { parent: any, prop: any }
  required?: boolean;
}

const TextFieldComponent =  <T extends FieldValues>({ name, label, control, errors, style, fieldProps, composedName, required }: TextFieldProps<T>) => {
  const castedErrors = errors as Record<string, any>;

  const composedError = composedName && composedName.parent && composedName.prop
    ? castedErrors?.[composedName.parent]?.[composedName.prop]
    : undefined;

  return <Box {...style} >
    <Text as="label" size="2" className={styles.label}>{<span>{label} {required && <span style={{ color: 'red' }}>*</span>}</span>}</Text>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField.Root
          size="2"
          {...field}
          {...fieldProps}
          value={field.value ?? ""}
        />
      )}
    />
    {composedError ? (
      <Text color="red" size="1">
        {composedError.message as string}
      </Text>
    ) : (
      errors?.[name] && (
        <Text color="red" size="1">
          {errors?.[name]?.message as string}
        </Text>
      )
    )}
  </Box>
};

export default TextFieldComponent;